<template>
  <div class="personal-data-component">
    <div class="personal-data">
      <ProfileNavbar></ProfileNavbar>
      <div class="data-wrap">
        <div class="base-info-wrap">
          <div class="address-info-wrap">
            <div class="address-count-tip">共{{ list.length }}个发票抬头，最多保存10个</div>
            <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border fit
              highlight-current-row>
              <el-table-column label="发票抬头" align="center" minWidth="150" prop="payee">
                <template slot-scope="{row}">
                  <p>{{ row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column label="发票类型" align="center" width="150" prop="type_name">
              </el-table-column>
              <el-table-column label="抬头类型" align="center" width="150" prop="header_type_name">
              </el-table-column>
              <el-table-column label="是否默认" align="center" minWidth="80">
                <template slot-scope="{row}">
                  <p>{{ row.is_default ? '是' : '否' }}</p>
                </template>
              </el-table-column>
              <el-table-column label="备注信息" align="center" width="150" prop="remark">
              </el-table-column>
              <el-table-column label="操作" align="center" width="200" fixed="right">

                <template slot-scope="{row}">
                  <el-button type="text" @click="handleShowEditHeader(row)">编辑</el-button>
                  <el-button type="text" @click="handleDeleteHeader(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="add-address-wrap" @click="handleShowAddHeader">
              <div class="add-icon">+</div>
              <p>新增发票抬头（最多添加10个）</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建发票抬头 -->
    <add-header :visible.sync="showAddForm" @getList="getList" />
    <!-- 编辑发票抬头 -->
    <edit-header :oldHeader="oldHeader" :visible.sync="showEditForm" @getList="getList" />
  </div>
</template>

<script>
import { getHeaderList, deleteHeader } from "@/api/header";
import ProfileNavbar from "@/components/profileNavbar"
import AddHeader from "./components/addHeader"
import EditHeader from "./components/editHeader"
export default {
  name: 'UserHeader',
  components: {
    ProfileNavbar,
    AddHeader,
    EditHeader,
  },
  data() {
    return {
      loading: false,
      showAddForm: false,
      showEditForm: false,
      list: [],
      oldHeader: {},
      emptyText: '暂无数据',
      total: 0,
      listQuery: {
        page: 1,
        pagesize: 10
      },
    };
  },
  computed: {

  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getHeaderList({}).then(res => {
        this.list = res.data.list;
        this.total = res.data.count * 1;
        this.loading = false;
      }).catch((err) => {

      });
    },
    // 删除项目
    handleDeleteHeader(header) {
      this.$confirm('确定要删除此发票抬头吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        deleteHeader({
          id: header.id
        })
          .then((response) => {
            this.loading = false;
            this.getList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    handleShowAddHeader() {
      this.showAddForm = true;
    },
    handleShowEditHeader(header) {
      this.oldHeader = header
      this.showEditForm = true;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/profile.less';
</style>
